<template>
    <rkm-overlay>
        <rkm-layout-body title="Importar laudo">

            <template v-slot:actions>

                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click.stop="$refs.List.openMultiple()"
                    color="primary"
                >
                    Importar laudos
                </rkm-button>
            </template>

            <rkm-layout-content v-if="loaded">
                <List
                    :data="{ form }"
                    ref="List"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/exame-laboratorial/importar-laudo/List'

import { mapActions } from 'vuex'
import { repository, error, object, data } from '@/mixins'

export default {
    components: { List },
    created() {

        this.repositories = {
            laudo: this.getConectaSusRepository('exameLaboratorial.importarLaudo')
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        form: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.laudo.create()
                .then(({ data }) => {

                    this.form = data.form
                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleExit() {

            this.redirectToList();
        },
        redirectToList() {

            this.$router.push({ name: 'dashboard' })
        },
    },
    mixins: [repository, error, object, data]
}
</script>